(function(app) {

    app.constant("transactionStagesToUiRouter",
    [
        { TransactionStage: "OptionalForms", UiRouterRoute: "Transaction.Application.OptionalForms" },
        { TransactionStage: "PaperApplication", UiRouterRoute: "Transaction.Application.PaperApplication" },
        { TransactionStage: "Prefill", UiRouterRoute: "Transaction.Application.Prefill" },
        { TransactionStage: "Terminate", UiRouterRoute: "Transaction.Application.Terminate" },
        { TransactionStage: "WorkflowChoice", UiRouterRoute: "Transaction.Application.WorkflowChoice" },
        { TransactionStage: "Finances", UiRouterRoute: "Transaction.Capture.Finances" },
        { TransactionStage: "Funding", UiRouterRoute: "Transaction.Capture.Funding" },
        { TransactionStage: "Households", UiRouterRoute: "Transaction.Capture.Households" },
        { TransactionStage: "NeededDocuments", UiRouterRoute: "Transaction.Capture.NeededDocuments" },
        { TransactionStage: "Questionnaire", UiRouterRoute: "Transaction.Capture.Questionnaire" },
        { TransactionStage: "RetireUp", UiRouterRoute: "Transaction.Capture.Retireup" },
        { TransactionStage: "Documents", UiRouterRoute: "Transaction.Determine.Documents" },
        { TransactionStage: "ProductChoice", UiRouterRoute: "Transaction.Determine.ProductChoice" },
        { TransactionStage: "ProductShelf", UiRouterRoute: "Transaction.Determine.ProductShelf" },
        { TransactionStage: "Inforce", UiRouterRoute: "Transaction.Determine.Inforce" },
        { TransactionStage: "Disclose", UiRouterRoute: "Transaction.Disclose" }
    ]);

})(window.app); //jshint ignore: line